// Indice de masse corporelle (IMC) et zones OMS (classification adulte).
import { round } from './statistics';

// Catégories OMS de l'IMC adulte.
export type BmiCategory =
  | 'underweight'
  | 'normal'
  | 'overweight'
  | 'obese_1'
  | 'obese_2'
  | 'obese_3';

// IMC = poids(kg) / taille(m)². NaN si taille invalide.
export function bmi(weightKg: number, heightCm: number): number {
  if (heightCm <= 0) return NaN;
  const m = heightCm / 100;
  return round(weightKg / (m * m), 1);
}

export function bmiCategory(value: number): BmiCategory {
  if (value < 18.5) return 'underweight';
  if (value < 25) return 'normal';
  if (value < 30) return 'overweight';
  if (value < 35) return 'obese_1';
  if (value < 40) return 'obese_2';
  return 'obese_3';
}

export const BMI_LABELS: Record<BmiCategory, string> = {
  underweight: 'Maigreur',
  normal: 'Corpulence normale',
  overweight: 'Surpoids',
  obese_1: 'Obésité modérée (I)',
  obese_2: 'Obésité sévère (II)',
  obese_3: 'Obésité morbide (III)',
};

// Plage de poids « saine » (IMC 18.5–24.9) pour une taille donnée.
export function healthyWeightRange(heightCm: number): { minKg: number; maxKg: number } {
  const m = heightCm / 100;
  return {
    minKg: round(18.5 * m * m, 1),
    maxKg: round(24.9 * m * m, 1),
  };
}
